import React, { Component } from 'react';
import Firebase from 'firebase';
import { Route, Link } from 'react-router-dom';
import Select from 'react-select';

const gps_options = [
    { label: "Si", value: "1" },
    { label: "No", value: "0" },
    { label: "Si, solo si esta disponible", value: "2" }
]

export default class templateItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            full: false,
            button: "fa fa-bars",
            gps: props.formulario.gps,
            alReady: 0
        }
    }

    sendTemplate() {
        var form = this.props.formulario;
        form.client_id = localStorage.client_id;
        var newPostKey = Firebase.database().ref().child('forms').push().key;
        var formRef = Firebase.database().ref('forms');
        formRef.child(newPostKey).set(
            [form][0]
        ).then(resp => {
            this.props.setTab();
        })
    }

    componentDidMount() {
        var tag = 0;
        var formRef = Firebase.database().ref("forms").orderByChild("client_id").equalTo(localStorage.client_id);
        formRef.once("value").then(resp => {
            resp.forEach(form => {
                if (form.val().tag === this.props.formulario.tag) {
                    tag = tag + 1;
                }
            });
            if (tag > 0) {
                this.setState({ alReady: 1 })
            } else {
                this.setState({ alReady: 2 })
            }
        })

    }

    renderButton() {
        switch (this.state.alReady) {
            case 0:
                return (
                    <div>
                    </div>
                )
            case 1:
                return (
                    <button type="button" className="btn btn-outline-primary" style={{ cursor: "not-allowed" }} disabled>
                        <i className="fa fa-check-square-o" aria-hidden="true"></i> En mi lista
                                </button>
                )
            case 2:
                return (
                    <button type="button" className="btn btn-outline-success" style={{ cursor: "pointer" }} onClick={() => this.sendTemplate()}>
                        <i className="fa fa-check-square-o" aria-hidden="true"></i> Añadir
                </button>
                )
        }
    }


    render() {
        var url;
        if (this.props.formulario.icon) {
            url = 'iconos/' + this.props.formulario.icon + ".svg";
        } else {
            url = 'iconos/test.svg';
        }
        return (
            <div className="form-group row" style={{ border: "1px solid #CCC", borderRadius: "5px", height: "200px", boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)" }}>
                <div className="col-md-4" style={{ background: "url(img/background_draft.png)", borderBottomLeftRadius: "3px", borderTopLeftRadius: "3px" }}>
                    <img className="img-responsive" src={url} style={{ position: "relative", top: "20px" }} />
                    <b style={{ position: "absolute", bottom: "0", left: "20px", color: "#FFF" }} >Plantilla</b>
                </div>
                <div className="col-md-8">
                    <h2 style={{ top: "15px", position: "relative" }}>{this.props.formulario.name}</h2>
                    <p>
                        {this.props.formulario.description}
                    </p>
                    <div style={{ position: "absolute", bottom: "2", right: "1" }}>
                        {
                            this.renderButton()
                        }
                    </div>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/views/forms/templateItem.js